import React from "react";
import cs from "classnames";

import closeWarning from "../../../../../assets/posttruck/closewarning.svg";
import css from "./style.css";

const showtype = {
  success: {
    icon: closeWarning(),
    style: css.success,
  },
  info: {
    icon: closeWarning(),
    style: css.info,
  },
  warning: {
    icon: closeWarning(),
    style: css.warning,
  },
  error: {
    icon: closeWarning(),
    style: css.error,
  },
};

const defaultConfig = {
  type: "",
  showClose: false,
  showIcon: false,
  message: "",
  description: "",
  close: null,
};

class Prompt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...Object.assign({}, defaultConfig, props),
      ...(showtype[props.type] ? showtype[props.type] : showtype["error"]),
    };
  }
  render() {
    //  Rate cannot be calculated, please enter pickup & dropoff location so we
    //  can calculate the rate upon the total price you have entered.
    return (
      <section className={cs(css.prompt, this.state.style)}>
        <span className={css.icon}>{this.state.icon}</span>
        <span className={css.content}>
          {this.state.message && (
            <p className={css.message}>{this.state.message}</p>
          )}
          {this.state.description && (
            <p className={css.description}>{this.state.description}</p>
          )}
        </span>
        {this.state.showClose && this.state.close && (
          <span className={css.close} onClick={this.state.close}>
            x
          </span>
        )}
      </section>
    );
  }
}

export default Prompt;



// WEBPACK FOOTER //
// ./src/pages/PostTruck/compontents/Prompt/index.js